<template>
  <div>
    <v-img
      class="mb-6"
      src="@/assets/dsc_giris_logo.png"
      max-height="350"
      min-height="150"
    ></v-img>
    <h2 class="mb-3 google-sans-medium">ÖDEV PLATFORMU</h2>
  </div>
</template>

<script>
export default {
  name: "DscLogo",
};
</script>

<style>
</style>